import { useAuthStore } from '../../../stores/authStore';
import { useSettings } from '../../../hooks/useSettings';
import { Skeleton } from '../../../components/common/Skeleton';
import { Toast } from '../../../components/common/Toast';
import { BusinessProfile } from '../../../components/settings/BusinessProfile';
import { SettingsSubPage } from '../components/SettingsSubPage';
import { palette, admin } from '../../../styles/tokens';

export function BusinessProfilePage() {
  const authBusiness = useAuthStore(s => s.business);
  const { business, loading, error, saved, updateBusinessProfile } = useSettings(authBusiness?.id);

  if (loading) {
    return (
      <SettingsSubPage title="Business profile" description="Name, address, phone, logo, industry, timezone">
        <div style={{ padding: 20, background: palette.white, borderRadius: admin.cardRadius, border: `1px solid ${admin.border}` }}>
          <Skeleton width={200} height={16} style={{ marginBottom: 12 }} />
          <Skeleton height={14} style={{ marginBottom: 8 }} />
          <Skeleton height={14} />
        </div>
      </SettingsSubPage>
    );
  }

  if (error || !business) {
    return (
      <SettingsSubPage title="Business profile" description="Name, address, phone, logo, industry, timezone">
        <div style={{ padding: 40, textAlign: 'center', color: palette.red, fontSize: 13.5 }}>
          {error ?? 'Business not found'}
        </div>
      </SettingsSubPage>
    );
  }

  return (
    <SettingsSubPage title="Business profile" description="Name, address, phone, logo, industry, timezone">
      <Toast message="Profile saved." type="success" isVisible={saved} onDismiss={() => {}} />
      <BusinessProfile business={business} onSave={updateBusinessProfile} />
    </SettingsSubPage>
  );
}
